export default __webpack_public_path__ + "static/media/wave.76de3b81.svg";